"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconFamily = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M1 9.1 10 1 19 9.1 16.3 9.1 16.3 16.3 3.7 16.3 3.7 9.1 1 9.1M10 14.5 10.648 13.906C12.97 11.8 14.5 10.414 14.5 8.713C14.5 7.327 13.411 6.238 12.025 6.238C11.242 6.238 10.495 6.607 10 7.183C9.505 6.607 8.758 6.238 7.975 6.238C6.589 6.238 5.5 7.327 5.5 8.713C5.5 10.414 7.03 11.8 9.352 13.906L10 14.5Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconFamily')(IconFamily);